import React, { useState } from "react";
import {  useNavigate } from "react-router-dom";
import "./CarBooking.css";
import { useLocation } from "react-router-dom";
import MahindraScorpio from "../../assets/MahindraScorpio.png";
import TataSafari from "../../assets/TataSafari.png";
import HyundaiCreta from "../../assets/HyundaiCreta.png"
import TataIndigo from "../../assets/TataIndigo.png"
import HondaCity from "../../assets/HondaCity.png"
import MarutiSwift from "../../assets/MarutiSwift.png"
import Hyundaii20 from "../../assets/Hyundaii20.png"
import ToyotaInnova from "../../assets/ToyotaInnova.png"
import MarutiErtiga from "../../assets/MarutiErtiga.png"
import BMW2Series from "../../assets/BMW2Series.png"
import AudiA5 from "../../assets/AudiA5.png"
import MiniCooperConvertible from "../../assets/MiniCooperConvertible.png"
import BMWZ4 from "../../assets/BMWZ4.png";
const carData = {
  SUV: [
    {
      name: "Mahindra Scorpio",
      fuels: ["Diesel"],
     img:MahindraScorpio,
    },
    {
      name: "Tata Safari",
      fuels: ["Diesel"],
      img: TataSafari,
    },
    {
      name: "Hyundai Creta",
      fuels: ["Petrol", "Diesel"],
      img: HyundaiCreta,
    },
  ],
  Sedan: [
    {
      name: "Tata Indigo",
      fuels: ["Petrol", "Diesel", "CNG"],
      img: TataIndigo,
    },
    {
      name: "Honda City",
      fuels: ["Petrol"],
      img: HondaCity,
    },
  ],
  Hatchback: [
    {
      name: "Maruti Swift",
      fuels: ["Petrol", "CNG"],
      img: MarutiSwift,
    },
    {
      name: "Hyundai i20",
      fuels: ["Petrol"],
      img: Hyundaii20,
    },
  ],
  MUV: [
    {
      name: "Toyota Innova",
      fuels: ["Diesel", "Petrol"],
      img: ToyotaInnova,
    },
    {
      name: "Maruti Ertiga",
      fuels: ["Petrol", "CNG"],
      img: MarutiErtiga,
    },
  ],
  Coupe: [
    {
      name: "BMW 2 Series",
      fuels: ["Petrol"],
      img: BMW2Series,
    },
    {
      name: "Audi A5",
      fuels: ["Petrol"],
      img: AudiA5,
    },
  ],
  Convertible: [
    {
      name: "Mini Cooper Convertible",
      fuels: ["Petrol"],
      img: MiniCooperConvertible,
    },
    {
      name: "BMW Z4",
      fuels: ["Petrol"],
      img: BMWZ4,
    },
  ],
};

const generateAllCards = () => {
  let cards = [];
  let id = 0;

  Object.keys(carData).forEach((type) => {
    carData[type].forEach((model) => {
      model.fuels.forEach((fuel) => {
        ["AC", "Non-AC"].forEach((acType) => {
          cards.push({
            id: id++,
            name: model.name,
            type: type,
            fuel: fuel,
            capacity: "4-6",
            ac: acType,
            price: acType === "AC" ? 1200 : 900,
            rating: (4 + Math.random()).toFixed(1),
            img: model.img,
          });
        });
      });
    });
  });

  return cards;
};

const CarBooking = () => {

  const location = useLocation();
  const navigate = useNavigate();

  let tripData = location.state;

  // fallback
  if (!tripData) {
    const saved = localStorage.getItem("tripData");
    tripData = saved ? JSON.parse(saved) : null;
  }

  const [carType, setCarType] = useState("");
  const [carModel, setCarModel] = useState("");
  const [fuelType, setFuelType] = useState("");

  const models = carType ? carData[carType] : [];
  const fuels = models.find((m) => m.name === carModel)?.fuels || [];

  let cards = [];
const selectedModel = models.find((m) => m.name === carModel);
  if (carType && carModel && fuelType) {
    cards = [
      {
        id: 1,
        name: carModel,
        type: carType,
        fuel: fuelType,
        capacity: "4-6",
        ac: "AC",
        price: 1200,
        rating: 4.5,
        img: selectedModel?.img,
      },
      {
        id: 2,
        name: carModel,
        type: carType,
        fuel: fuelType,
        capacity: "4-6",
        ac: "Non-AC",
        price: 900,
        rating: 4.2,
        img: selectedModel?.img,
      },
    ];
  } else {
    cards = generateAllCards();
  }

 const handleSelectCab = (car) => {
   const bookingData = {
     carData: car,
     extraCharges: 200,
     fuelCharges: 300,
     driverCharges: 250,
     nightCharges: 150,

    
     pickup: tripData?.pickup,
     drop: tripData?.drop,
     bookingDate: tripData?.date,
     bookingTime: tripData?.time,
   };

   // save (optional but important)
   localStorage.setItem("bookingData", JSON.stringify(bookingData));

   navigate("/booking-detail-page", {
     state: bookingData,
   });
 };




  return (
    <div className="container">
      <h2>Book Your Cab</h2>

      <div className="dropdowns">
        <select
          value={carType}
          onChange={(e) => {
            setCarType(e.target.value);
            setCarModel("");
            setFuelType("");
          }}
        >
          <option value="">Select Car Type</option>
          {Object.keys(carData).map((type) => (
            <option key={type}>{type}</option>
          ))}
        </select>

        <select
          value={carModel}
          onChange={(e) => {
            setCarModel(e.target.value);
            setFuelType("");
          }}
          disabled={!carType}
        >
          <option value="">Select Car Model</option>
          {models.map((m) => (
            <option key={m.name}>{m.name}</option>
          ))}
        </select>

        <select
          value={fuelType}
          onChange={(e) => setFuelType(e.target.value)}
          disabled={!carModel}
        >
          <option value="">Select Fuel Type</option>
          {fuels.map((f) => (
            <option key={f}>{f}</option>
          ))}
        </select>
      </div>

      <div className="booking-car-card-container">
        {cards.map((car) => (
          <div className="car-booking-package-card" key={car.id}>
            <div className="rating">⭐ {car.rating}</div>
            <img src={car.img} alt={car.name} />
            <h3>{car.name}</h3>
            <p>Type: {car.type}</p>
            <p>Fuel: {car.fuel}</p>
            <p>Capacity: {car.capacity}</p>
            <p>{car.ac}</p>
            <p className="price">₹{car.price}</p>
            <button
              className="select-cab-btn"
              onClick={() => handleSelectCab(car)}
            >
              Select Cab
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarBooking;
